export default __webpack_public_path__ + "static/media/support-donation.dfd7aa09.png";